import { render, staticRenderFns } from "./OfertaLaboral.vue?vue&type=template&id=d65c7550&scoped=true&"
import script from "./OfertaLaboral.vue?vue&type=script&lang=js&"
export * from "./OfertaLaboral.vue?vue&type=script&lang=js&"
import style0 from "./OfertaLaboral.vue?vue&type=style&index=0&id=d65c7550&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65c7550",
  null
  
)

export default component.exports